<app-modal
  [isVisible]="isVisible()"
  [config]="modalConfig()"
  [primaryButtonDisabled]="primaryButtonDisabled()"
  [primaryButtonLoading]="isLoading()"
  (confirmed)="onModalConfirmed()"
  (cancelled)="onModalCancelled()"
  (secondary)="onModalCancelled()"
  (closed)="onModalClosed()"
>
  <!-- Header Icon -->
  <div class="modal-header-icon">
    <app-icon iconKey="group" [showLabel]="false" />
  </div>

  <!-- Description -->
  <p class="modal-description">{{ 'modals.invite_member.description' | transloco }}</p>

  <!-- Error Message -->
  @if (error(); as err) {
    <div class="modal-error">
      <span>{{ err }}</span>
      <button type="button" (click)="clearError()">×</button>
    </div>
  }

  <!-- Form Fields -->
  <div class="field">
    <label for="invite-email">{{ 'modals.invite_member.email_label' | transloco }}</label>
    <div class="input-wrapper">
      <input
        id="invite-email"
        type="email"
        placeholder="member@example.com"
        [ngModel]="email()"
        (ngModelChange)="email.set($event); clearError()"
        [disabled]="isLoading()"
      />
      <app-icon iconKey="email" [showLabel]="false" class="input-trailing-icon" />
    </div>
    <small>{{ 'modals.invite_member.email_hint' | transloco }}</small>
  </div>

  <div class="field">
    <label for="invite-role">{{ 'modals.invite_member.role_label' | transloco }}</label>
    <app-select
      variant="form"
      inputId="invite-role"
      [options]="roleOptions()"
      [clearable]="false"
      [disabled]="isLoading()"
      [value]="role()"
      (valueChange)="role.set($any($event)); clearError()"
    />
    <small>{{ 'modals.invite_member.role_hint' | transloco }}</small>
  </div>
</app-modal>
